export default "__VITE_ASSET__f5534670__"